/* ---------- Header: recolhe ao rolar pra baixo, some tema claro/escuro
   conforme a seção visível atrás dele ---------- */
(function () {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const themedSections = Array.from(document.querySelectorAll('[data-header-theme]'));
  const cartBadge = document.querySelector('.cart-badge');
  const setHeaderHeightVar = () => {
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  };
  setHeaderHeightVar();
  window.addEventListener('resize', setHeaderHeightVar);
  if (window.ResizeObserver) {
    new ResizeObserver(setHeaderHeightVar).observe(header);
  }

  const SCROLL_THRESHOLD = 40;
  const COMPACT_HEADER_HEIGHT = 78;

  let lastScrollY = window.scrollY;
  const isCartEmpty = () => !cartBadge || cartBadge.textContent.trim() === '0';

  const toggleHeader = () => {
    const currentScrollY = window.scrollY;
    const scrolled = currentScrollY > SCROLL_THRESHOLD;
    header.classList.toggle('site-header--scrolled', scrolled);

    const canHover = window.matchMedia('(hover: hover)').matches;
    if (currentScrollY <= SCROLL_THRESHOLD) {
      header.classList.remove('site-header--collapsed');
    } else if (currentScrollY > lastScrollY && isCartEmpty() && canHover) {
      header.classList.add('site-header--collapsed');
    } else if (currentScrollY < lastScrollY) {
      header.classList.remove('site-header--collapsed');
    }
    lastScrollY = currentScrollY;

    const probeY = COMPACT_HEADER_HEIGHT / 2;
    let theme = 'dark';
    for (const section of themedSections) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= probeY && rect.bottom > probeY) {
        theme = section.dataset.headerTheme;
        break;
      }
    }
    header.classList.toggle('site-header--on-light', theme === 'light');
  };

  window.addEventListener('scroll', toggleHeader, { passive: true });
  window.addEventListener('resize', toggleHeader);
  toggleHeader();

  const headerInner = header.querySelector('.header-inner');
  headerInner.addEventListener('mouseenter', () => header.classList.add('site-header--peek'));
  headerInner.addEventListener('mouseleave', () => header.classList.remove('site-header--peek'));
})();

/* ---------- Busca do header: barra que desce abaixo do header.
   O form aponta pra busca nativa do Shopify (routes.search_url). ---------- */
document.querySelectorAll('[data-header-search]').forEach((wrap) => {
  const toggleBtn = wrap.querySelector('[data-search-toggle]');
  const bar = document.getElementById(toggleBtn.getAttribute('aria-controls'));
  if (!bar) return;
  const form = bar.querySelector('[data-search-form]');
  const input = bar.querySelector('[data-search-input]');
  const closeBtn = bar.querySelector('[data-search-close]');

  const openSearch = () => {
    bar.hidden = false;
    toggleBtn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => bar.classList.add('is-open'));
    input.focus();
  };
  const closeSearch = (opts) => {
    bar.classList.remove('is-open');
    toggleBtn.setAttribute('aria-expanded', 'false');
    setTimeout(() => { bar.hidden = true; }, 280);
    if (opts && opts.returnFocus) toggleBtn.focus();
  };

  toggleBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    bar.hidden ? openSearch() : closeSearch();
  });
  closeBtn.addEventListener('click', () => closeSearch({ returnFocus: true }));
  document.addEventListener('click', (e) => {
    if (!bar.hidden && !bar.contains(e.target) && !wrap.contains(e.target)) closeSearch();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !bar.hidden) closeSearch({ returnFocus: true });
  });
  // form já tem action="{{ routes.search_url }}" e o input name="q" no Liquid -
  // não precisa de preventDefault, deixa o navegador enviar de verdade.
});

/* ---------- Menu mobile: drawer com backdrop, trap de foco, Esc fecha ---------- */
(function () {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.getElementById('mobileNav');
  if (!toggle || !nav) return;
  const navPanel = nav.querySelector('.mobile-nav-panel');
  let navLastFocused = null;

  const openNav = () => {
    navLastFocused = document.activeElement;
    nav.hidden = false;
    document.body.style.overflow = 'hidden';
    toggle.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => nav.classList.add('is-open'));
    const closeBtn = nav.querySelector('.mobile-nav-close');
    if (closeBtn) closeBtn.focus();
  };

  const closeNav = () => {
    nav.classList.remove('is-open');
    toggle.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    const finish = () => {
      nav.hidden = true;
      navPanel.removeEventListener('transitionend', finish);
    };
    navPanel.addEventListener('transitionend', finish);
    setTimeout(finish, 450);
    if (navLastFocused && navLastFocused.focus) navLastFocused.focus();
  };

  toggle.addEventListener('click', () => {
    if (nav.classList.contains('is-open')) closeNav();
    else openNav();
  });

  nav.querySelectorAll('[data-nav-close]').forEach((el) => {
    el.addEventListener('click', closeNav);
  });

  nav.querySelectorAll('.mobile-nav-link').forEach((link) => {
    link.addEventListener('click', closeNav);
  });

  document.addEventListener('keydown', (e) => {
    if (nav.hidden) return;
    if (e.key === 'Escape') {
      closeNav();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = navPanel.querySelectorAll('button:not([disabled]), a[href]');
    const list = Array.from(focusable).filter((el) => el.offsetParent !== null);
    if (!list.length) return;
    const first = list[0];
    const last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();

/* ---------- Carrinho: painel lateral ligado na Ajax Cart API do Shopify
   (/cart/add.js, /cart/change.js, /cart.js) - substitui o protótipo que
   guardava tudo em localStorage. Dispara "alvesvita:cart-updated" no
   window sempre que o carrinho muda, pra outras partes do tema (ex.:
   resumo do pedido) poderem escutar. ---------- */
(function () {
  const drawer = document.getElementById('cartDrawer');
  if (!drawer) return;

  // Loja é BRL only - formata direto em vez de depender do money.js do Shopify.
  const formatMoney = (cents) => 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');

  const panel = drawer.querySelector('.cart-drawer-panel');
  const listEl = drawer.querySelector('.cart-drawer-list');
  const emptyEl = drawer.querySelector('.cart-drawer-empty');
  const subtotalEl = drawer.querySelector('.cart-drawer-subtotal-value');
  const countEl = drawer.querySelector('.cart-drawer-count');
  const checkoutLink = drawer.querySelector('[data-checkout-link]');
  const shippingEl = drawer.querySelector('[data-cart-shipping]');
  const freeShippingMin = Number(drawer.dataset.freeShippingMin || 0) * 100; // em centavos
  let lastFocused = null;

  const renderFromCart = (cart) => {
    const totalQty = cart.item_count;
    document.querySelectorAll('.cart-badge').forEach((b) => { b.textContent = String(totalQty); });
    document.querySelectorAll('.cart-btn').forEach((b) => {
      b.setAttribute('aria-label', `Carrinho, ${totalQty} ${totalQty === 1 ? 'item' : 'itens'}`);
    });
    if (countEl) countEl.textContent = totalQty ? `(${totalQty})` : '';
    if (checkoutLink) {
      checkoutLink.disabled = totalQty === 0;
      checkoutLink.setAttribute('aria-disabled', totalQty ? 'false' : 'true');
    }

    listEl.innerHTML = '';
    const hasItems = cart.items.length > 0;
    emptyEl.hidden = hasItems;
    listEl.hidden = !hasItems;

    cart.items.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'cart-item';

      const imgWrap = document.createElement('span');
      imgWrap.className = 'cart-item-img';
      const img = document.createElement('img');
      img.src = item.image || '';
      img.alt = '';
      imgWrap.appendChild(img);

      const info = document.createElement('span');
      const name = document.createElement('p');
      name.className = 'cart-item-name';
      name.textContent = item.product_title;
      const kit = document.createElement('p');
      kit.className = 'cart-item-kit';
      kit.textContent = item.variant_title || '';

      const qtyWrap = document.createElement('span');
      qtyWrap.className = 'cart-item-qty';
      const decBtn = document.createElement('button');
      decBtn.type = 'button';
      decBtn.setAttribute('aria-label', 'Diminuir quantidade');
      decBtn.textContent = '−';
      const qtyNum = document.createElement('span');
      qtyNum.textContent = String(item.quantity);
      const incBtn = document.createElement('button');
      incBtn.type = 'button';
      incBtn.setAttribute('aria-label', 'Aumentar quantidade');
      incBtn.textContent = '+';
      qtyWrap.append(decBtn, qtyNum, incBtn);

      const price = document.createElement('p');
      price.className = 'cart-item-price';
      price.textContent = formatMoney(item.final_line_price);
      info.append(name, kit, price);

      const side = document.createElement('span');
      side.className = 'cart-item-side';
      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'cart-item-remove';
      removeBtn.textContent = 'Remover';
      side.append(qtyWrap, removeBtn);

      li.append(imgWrap, info, side);
      incBtn.addEventListener('click', () => changeQty(item.key, item.quantity + 1));
      decBtn.addEventListener('click', () => changeQty(item.key, item.quantity - 1));
      removeBtn.addEventListener('click', () => changeQty(item.key, 0));
      listEl.appendChild(li);
    });

    subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

    if (shippingEl) {
      if (!hasItems || !freeShippingMin) {
        shippingEl.hidden = true;
      } else if (cart.items_subtotal_price >= freeShippingMin) {
        shippingEl.hidden = false;
        shippingEl.classList.add('is-unlocked');
        shippingEl.textContent = 'Frete grátis garantido nesta compra.';
      } else {
        shippingEl.hidden = false;
        shippingEl.classList.remove('is-unlocked');
        shippingEl.textContent = `Faltam ${formatMoney(freeShippingMin - cart.items_subtotal_price)} para o frete grátis.`;
      }
    }

    window.dispatchEvent(new CustomEvent('alvesvita:cart-updated', { detail: cart }));
  };

  const fetchCart = () => fetch('/cart.js').then((r) => r.json());

  const refresh = () => fetchCart().then(renderFromCart);

  const changeQty = (key, quantity) => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then((r) => r.json())
      .then(renderFromCart);
  };

  const openDrawer = () => {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    const closeBtn = drawer.querySelector('.cart-drawer-close');
    if (closeBtn) closeBtn.focus();
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    const finish = () => {
      drawer.hidden = true;
      panel.removeEventListener('transitionend', finish);
    };
    panel.addEventListener('transitionend', finish);
    setTimeout(finish, 450);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  };

  document.querySelectorAll('.cart-btn').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

  drawer.querySelectorAll('[data-cart-close]').forEach((el) => {
    el.addEventListener('click', (e) => { e.preventDefault(); closeDrawer(); });
  });

  if (checkoutLink) {
    checkoutLink.addEventListener('click', (e) => {
      if (checkoutLink.getAttribute('aria-disabled') === 'true') e.preventDefault();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (drawer.hidden) return;
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = panel.querySelectorAll('button:not([disabled]), a[href]');
    const list = Array.from(focusable).filter((el) => el.offsetParent !== null);
    if (!list.length) return;
    const first = list[0];
    const last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Qualquer form de produto no tema (main-product, cards de kit etc.) usa
  // esse mesmo padrão: data-add-to-cart-form + envia pro /cart/add.js.
  document.querySelectorAll('[data-add-to-cart-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: new FormData(form).get('id'), quantity: 1 }],
        }),
      })
        .then((r) => r.json())
        .then(() => refresh())
        .then(() => openDrawer())
        .catch(() => {})
        .finally(() => { if (submitBtn) submitBtn.disabled = false; });
    });
  });

  window.alvesvitaCart = { open: openDrawer, refresh };
  refresh();
})();

/* ---------- Boas-vindas: só na primeira visita ao site.
   O formulário ainda não está ligado a um serviço de e-mail real - por
   enquanto só marca "visto" no localStorage. Trocar por um formulário de
   newsletter do Shopify (customer[tags]=newsletter) quando for pra valer. ---------- */
(function () {
  const welcome = document.getElementById('welcome');
  if (!welcome) return;
  const SEEN_KEY = 'alvesvita:welcome-seen';
  const card = welcome.querySelector('.welcome-card');
  const form = welcome.querySelector('.welcome-form');
  const field = welcome.querySelector('.welcome-field input');
  const errorMsg = welcome.querySelector('.welcome-error');
  const done = welcome.querySelector('.welcome-done');
  const copyBtn = welcome.querySelector('[data-welcome-copy]');
  const closeBtn = welcome.querySelector('.welcome-close');
  let lastFocused = null;

  const storage = (() => {
    try {
      const probe = '__t';
      window.localStorage.setItem(probe, probe);
      window.localStorage.removeItem(probe);
      return window.localStorage;
    } catch (err) {
      return null;
    }
  })();

  const markSeen = () => {
    try { if (storage) storage.setItem(SEEN_KEY, String(Date.now())); } catch (err) {}
  };

  const openWelcome = () => {
    lastFocused = document.activeElement;
    welcome.hidden = false;
    const gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.body.style.overflow = 'hidden';
    card.scrollTop = 0;
    requestAnimationFrame(() => {
      welcome.classList.add('is-open');
      card.scrollTop = 0;
      try {
        closeBtn.focus({ preventScroll: true });
      } catch (error) {
        closeBtn.focus();
      }
    });
  };

  const closeWelcome = () => {
    markSeen();
    welcome.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    const finish = () => {
      welcome.hidden = true;
      card.removeEventListener('transitionend', finish);
    };
    card.addEventListener('transitionend', finish);
    setTimeout(finish, 450);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  };

  welcome.querySelectorAll('[data-welcome-close]').forEach((el) => {
    el.addEventListener('click', closeWelcome);
  });

  document.addEventListener('keydown', (e) => {
    if (welcome.hidden) return;
    if (e.key === 'Escape') {
      closeWelcome();
      return;
    }
    if (e.key !== 'Tab') return;
    const focusable = card.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]');
    const list = Array.from(focusable).filter((el) => el.offsetParent !== null);
    if (!list.length) return;
    const first = list[0];
    const last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const value = field.value.trim();
      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
      errorMsg.hidden = valid;
      field.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid) {
        field.focus();
        return;
      }
      markSeen();
      form.hidden = true;
      done.hidden = false;
      const fine = welcome.querySelector('.welcome-fine');
      if (fine) fine.hidden = true;
      if (copyBtn) copyBtn.focus();
    });
  }

  if (copyBtn) {
    const hint = copyBtn.querySelector('.welcome-coupon-hint');
    copyBtn.addEventListener('click', () => {
      const code = copyBtn.querySelector('.welcome-coupon-code').textContent.trim();
      const show = (msg) => {
        if (!hint) return;
        hint.textContent = msg;
        setTimeout(() => { hint.textContent = 'copiar'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => show('copiado!'), () => show('copie o código'));
      } else {
        show('copie o código');
      }
    });
  }

  let alreadySeen = true;
  try { alreadySeen = !storage || storage.getItem(SEEN_KEY) !== null; } catch (err) {}
  if (!alreadySeen) setTimeout(openWelcome, 1200);
})();
